/*eslint-disable*/
import React from "react";
// database
import * as DATABASE from 'db';
// nodejs library that concatenates classes
import classNames from "classnames";
// Google Analytics Tracker
import Tracker from "useTracking.js"
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
// sections for this page
import SectionPricing from "views/SpecialsPage/Sections/SectionPricing.js";
import SectionServices from "views/SpecialsPage/Sections/SectionServices.js";
// styles
import pricingStyle from "assets/jss/material-kit-pro-react/views/pricingStyle.js";

const useStyles = makeStyles(pricingStyle);

export default function SpecialsPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    Tracker();
  });
  const classes = useStyles();
  return (
    <div>
      <Header
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="white"
        changeColorOnScroll={{
          height: 300,
          color: "white"
        }}
      />
      <Parallax
        image={require("assets/img/headers/favs/favs4.jpg")}
        small
        title={DATABASE.PROMO_HEADER.default ? DATABASE.PROMO_HEADER.defaultTitle : DATABASE.PROMO_HEADER.title}
        description={DATABASE.PROMO_HEADER.default ? DATABASE.PROMO_HEADER.defaultDescription : DATABASE.PROMO_HEADER.description}
        backgroundPosition={"center bottom"} />
      <div className={classNames(classes.main)}>
        <div className={classes.container}>
          {DATABASE.PROMO_SHOW_ALL && <SectionPricing />}
        </div>
        <div className={classes.containerFluid}>
          {DATABASE.PROMO_SHOW_ALL && <SectionServices />}
        </div>
      </div>
      <Footer theme="white" />
    </div>
  );
}
